<template>
  <RevContainer>
    <h2 class="text-static-default-hi heading-1 mb-4 flex md:justify-center">
      {{ i18n(translations.title) }}
    </h2>

    <PoliciesAndEligibleInsurances
      v-if="!isEmpty(policies)"
      :eligible-insurances
      :policies
    />

    <EligibleInsurances
      v-if="isEmpty(policies) && !isEmpty(eligibleInsurances)"
      :eligible-insurances
    />
  </RevContainer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { isEmpty } from '@ds/utils/isEmpty'

import translations from './ServicesHub.translations'
import EligibleInsurances from './pages/EligibleInsurances/EligibleInsurances.vue'
import PoliciesAndEligibleInsurances from './pages/PoliciesAndEligibleInsurances/PoliciesAndEligibleInsurances.vue'
import type { EligibleInsurance, Policy, PolicyState } from './types'

const i18n = useI18n()

// TODO Fetch policies
const policies: Policy[] = [
  {
    state: 'ACTIVE' as PolicyState,
    offerTitle: 'Protection Plan - Monthly',
    productTitle: 'iPhone 11 64GB - Space Gray - Unlocked',
    policyId: '1',
    startDate: '2020-08-19T14:00:00Z',
    endDate: '2020-08-19T14:00:00Z',
  },
]
const eligibleInsurances: EligibleInsurance[] = [
  {
    productTitle: 'Iphone 15',
    productImage:
      'https://d28i4xct2kl5lp.cloudfront.net/product_images/23774_2b392b5d-546c-4b28-8437-7d7f76f33f52.jpg',
    eligibilityEndDate: '2025-11-04T14:00:00Z',
    orderlineId: '123123',
    offerMinPrice: {
      amount: '123',
      currency: 'EUR',
    },
  },
  {
    productTitle: 'Iphone 15',
    productImage:
      'https://d28i4xct2kl5lp.cloudfront.net/product_images/23774_2b392b5d-546c-4b28-8437-7d7f76f33f52.jpg',
    eligibilityEndDate: '2025-11-04T14:00:00Z',
    orderlineId: '123123',
    offerMinPrice: {
      amount: '123',
      currency: 'EUR',
    },
  },
]
</script>
